/* eslint react/forbid-prop-types: 0 */
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Glyphicon } from "react-bootstrap";
import StatusHelper from "../StatusHelper";

const ViewLink = ({ path, jobId }) => (
  <Link className="custom-link" title="View Job" to={`${path}/jobs/${jobId}`}>
    <Glyphicon glyph="eye-open" />
  </Link>
);
ViewLink.propTypes = {
  path: PropTypes.string.isRequired,
  jobId: PropTypes.number.isRequired
};

const JobListItem = ({ job, path }) => {
  const jobType = job.type === "PICKUP" ? "Pickup" : "Delivery";

  return (
    <tr className="content">
      <td>{job.seq}</td>
      <td>{job.customerName}</td>
      <td>{jobType}</td>
      <td>{StatusHelper(job.status)}</td>
      <td>
        <ViewLink path={path} jobExternalId={job.externalId} jobId={job.id} />
      </td>
    </tr>
  );
};
JobListItem.propTypes = {
  job: PropTypes.object.isRequired,
  path: PropTypes.string.isRequired
};

export default JobListItem;



// WEBPACK FOOTER //
// ./src/components/jobs/JobListItem.js